<template>
  <a :href="'tel:+' + raw" class="phone" @click="handleClick">
    <slot />
  </a>
</template>

<script>
export default {
  name: "v-phone",
  props: {
    raw: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClick() {
      if (window.ym) {
        console.log("Counter: ", 48811595, " reached");
        ym(48811595, "reachGoal", "click_number");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
